import { observer } from "mobx-react-lite";
import DataGrid from "../../components/datatable/DataGrid";
import { types } from "mobx-state-tree";
import { DataGridStorageModel } from "../../components/datatable/DataGridStorage";
import { Column, ColumnType, DisplayValues } from "../../components/datatable/interfaces";
import React, { useEffect } from "react";
import { endpoints } from "../api/ApiEndpoints";
import { api } from "../api/ApiService";
import { translationService } from "../translation/TranslationService";
import { PubSubEvents } from "../PubSubEvents";

export interface FileConversionStatus {
    id: number,
    filename: string,
    status: boolean,
    sas: string
}

const columns : Column[] = [
    {
        key: "filename",
        name: "videoConversion.status.filename",
        type: ColumnType.String
    },
    {
        key: "status",
        name: "videoConversion.status.status",
        type: ColumnType.Boolean
    },
    {
        key: "sas",
        name: "videoConversion.status.link",
        type: ColumnType.String,
        containsLink: true
    }
]

const FileDownloaderStorageModel = types
    .compose(types.model({
        files: types.frozen<FileConversionStatus[]>()
    }) ,DataGridStorageModel)
    .named("FileDownloaderStorageModel")
    .actions((self) => {
        return {
            mapResponse(response: any) {
                self.gridColumns = columns;
                self.data = {
                    totalCount: 1,
                    items: self.files.map(self.mapItem)
                }
            },
            mapItem(item: any) {
                var displayValues : DisplayValues = {
                    id: {value: item.id, toDisplay: item.id},
                    filename: {value: item.filename, toDisplay: item.filename},
                    status: 
                    {
                        value: item.status,
                        toDisplay: item.status ? translationService.translate("videoConversion.status.converted") : translationService.translate("videoConversion.status.converting")
                    },
                    sas: 
                    {
                        value: item.sas,
                        toDisplay: item.sas ? 
                            translationService.translate("shop.shop-histroy.link") : "", 
                        path: item.sas,
                        absolute: true
                    }
                }
                return {
                    displayValues: displayValues,
                    id: item.id
                }
            }
        }
    })
    .views((self) => ({
        get endpoint() {
            return endpoints.get("get_activity_prices");
        },
        get isLoading() {
            return self.files.length === 0;
        },
        get canLoadItems() {
            return self.files.length !== 0;
        }
    }))

export default observer(function VideoConversionStatus(props: {files: FileConversionStatus[], onConversionFinished:() => void}) {
    useEffect(() => {
        var analysisSubscribeToken = PubSub.subscribe(
          PubSubEvents.VideoConversionFinished,
          async (_event: string, notification: Notification) => {
            props.onConversionFinished();
          }
        );
    
        return function cleanup() {
          PubSub.unsubscribe(analysisSubscribeToken);
        };
      }, [props.onConversionFinished]);

    return (
        <DataGrid
            dataGridStorage={FileDownloaderStorageModel.create({files: props.files, noPagination: true, showTotalAmount: false}, {api})} 
            itemTypeKey={""}
            noSelection
        />
    )
})